<template>
  <!-- 商品分类 -->
  <div class="productClassify">
    <!-- 面包屑导航 -->
    <crumbs-bar
      @refresh="handleRefresh"
      :crumbsList="['商品管理', $route.meta.title]"
    >
      <template slot="controls">
        <el-link
          @click="explain = true"
          style="margin-right: 10px"
          icon="el-icon-question"
          :underline="false"
          type="warning"
          >操作说明</el-link
        >
        <el-button
          type="primary"
          style="margin-right: 10px"
          icon="el-icon-circle-plus-outline"
          @click="handleAdd(false)"
          v-if="buttonVisibility.category"
          >新增分类</el-button
        >
        <el-link
          icon="el-icon-question"
          type="primary"
          style="margin-right: 10px"
          :href="baseUrl + '/UploadFile/Template/商品导入模板.xls'"
          target="_blank"
          >下载模板</el-link
        >
        <el-button
          type="danger"
          @click="handleDel()"
          v-if="buttonVisibility.delete"
        >删除</el-button>
      </template>
    </crumbs-bar>
    <!-- 数据展示 -->
    <el-table
      :data="tableData"
      stripe
      border
      height="calc(100% - 90px)"
      :row-style="{ color: '#303133' }"
      tooltip-effect="dark"
      @selection-change="selectionChange"
      style="width: 100%"
    >
      <el-table-column type="selection" align="center" width="55">
      </el-table-column>
      <el-table-column label="序号" align="center" type="index" width="70">
      </el-table-column>
      <el-table-column type="expand" label="展开" align="center" width="50">
        <template slot-scope="props">
          <el-table
            :data="props.row.childs"
            stripe
            border
            @selection-change="selectionChange"
            tooltip-effect="dark"
            style="width: 100%"
          >
            <el-table-column type="selection" align="center" width="55">
            </el-table-column>
            <el-table-column label="序号" align="center" width="70">
              <template slot-scope="scope">
                <span>{{ props.$index + 1 }}-{{ scope.$index + 1 }}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="classifyId"
              align="center"
              show-overflow-tooltip
              label="类别id"
            >
            </el-table-column>
            <el-table-column
              prop="name"
              align="center"
              show-overflow-tooltip
              label="类别名称"
            >
            </el-table-column>
            <el-table-column
              prop="grade"
              label="等级"
              align="center"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
              prop="sort"
              label="排序"
              align="center"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column label="操作" align="center">
              <template slot-scope="scope">
                <el-button
                  type="primary"
                  style="padding: 2px 3px"
                  plain
                  @click="handleGoods(scope)"
                  v-if="buttonVisibility.addGoods"
                  >添加商品</el-button
                >
                <el-button
                  type="primary"
                  style="padding: 2px 3px"
                  plain
                  @click="dropdownCommand(scope.row)"
                  v-if="buttonVisibility.import"
                  >导入</el-button
                >

                <el-button
                  type="warning"
                  style="padding: 2px 3px"
                  plain
                  @click="handleAdd(scope.row)"
                  v-if="buttonVisibility.edit"
                  >编辑</el-button
                >
                <!-- <el-button
                  type="danger"
                  style="padding: 2px 3px"
                  plain
                  @click="handleDel(scope.row)"
                  >删除</el-button
                > -->
              </template>
            </el-table-column>
          </el-table>
        </template>
      </el-table-column>
      <el-table-column
        prop="classifyId"
        align="center"
        show-overflow-tooltip
        label="类别id"
      >
      </el-table-column>
      <el-table-column
        prop="name"
        align="center"
        show-overflow-tooltip
        label="类别名称"
      >
      </el-table-column>
      <el-table-column
        prop="grade"
        label="等级"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="sort"
        label="排序"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          <el-button
            type="primary"
            style="padding: 2px 3px"
            plain
            @click="handleGoods(scope)"
            v-if="buttonVisibility.addGoods"
            >添加商品</el-button
          >
          <el-button
            type="warning"
            style="padding: 2px 3px"
            plain
            @click="handleAdd(scope.row)"
            v-if="buttonVisibility.edit"
            >编辑</el-button
          >
          <el-button
            type="primary"
            style="padding: 2px 3px"
            plain
            @click="dropdownCommand(scope.row)"
            v-if="buttonVisibility.import"
            >导入</el-button
          >
          <!-- <el-button
            type="danger"
            style="padding: 2px 3px"
            plain
            @click="handleDel(scope.row)"
            >删除</el-button
          > -->
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <pagination
      :allPage="allPage"
      :pageSize="pageSize"
      :currIndex="currPage"
      @hanSiChange="hanSiChange"
      @hanCurrChange="hanCurrChange"
    ></pagination>
    <upload
      ref="upload"
      style="display: none"
      @fileChange="uploadGoods"
      :multiple="true"
    ></upload>
    <!-- 编辑分类 -->
    <el-drawer
      :visible.sync="addDrawer"
      :withHeader="false"
      :close-on-press-escape="$store.state.closeOnPresEscape"
      :wrapperClosable="$store.state.closeOnClickModal"
      direction="rtl"
    >
      <div class="drawer-header">编辑分类</div>
      <el-scrollbar style="height: calc(100% - 90px)">
        <div class="drawer-form-wrap">
          <el-form
            :model="addForm"
            label-position="rigth"
            label-width="100px"
            :rules="addFormRule"
            ref="addForm"
          >
            <el-form-item label="父类别" prop="parent">
              <el-select
                v-model="addForm.parent"
                placeholder="请选择"
                clearable
                style="width: 100%"
              >
                <el-option label="开启" value="开启"></el-option>
                <el-option label="关闭" value="关闭"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="排序" prop="sort">
              <el-input v-model="addForm.sort" clearable></el-input>
            </el-form-item>
            <el-form-item label="类别名称" prop="name">
              <el-input v-model="addForm.name" clearable></el-input>
            </el-form-item>
            <el-form-item label="分类图片" prop="img">
              <img-upload action=""></img-upload>
            </el-form-item>
            <el-form-item label="调用别名" prop="alias">
              <el-input v-model="addForm.alias" clearable></el-input>
            </el-form-item>
            <el-form-item label="seo标题" prop="seoTit">
              <el-input v-model="addForm.seoTit" clearable></el-input>
            </el-form-item>
            <el-form-item label="seo描述" prop="seoDes">
              <el-input v-model="addForm.seoDes" clearable></el-input>
            </el-form-item>
          </el-form>
        </div>
      </el-scrollbar>
      <div class="drawer-footer">
        <el-button
          type="primary"
          @click="submit"
        >确定</el-button>
        <el-button
          type="info"
          @click="clearForm"
        >取消</el-button>
      </div>
    </el-drawer>

    <!-- 商品表格 -->
    <el-dialog
      title="添加商品"
      :visible.sync="addGoodsDialog"
      :close-on-click-modal="$store.state.closeOnClickModal"
      :close-on-press-escape="$store.state.closeOnPresEscape"
      width="800px"
    >
      <el-form label-width="120px">
        <el-form-item label="类别名称">
          <el-input
            style="width: 200px; margin-right: 5px"
            v-model="addGoodsForm.name"
            disabled
          >
          </el-input>
        </el-form-item>
        <el-form-item label="选中商品">
          <el-scrollbar style="width: 600px; height: 200px">
            <el-table
              :data="addGoodsForm.list"
              stripe
              border
              tooltip-effect="dark"
            >
              <el-table-column label="序号" align="center" width="50">
                <template slot-scope="scope">
                  <span>{{
                    (currPage - 1) * pageSize + scope.$index + 1
                  }}</span>
                </template>
              </el-table-column>
              <el-table-column
                prop="name"
                align="center"
                show-overflow-tooltip
                label="商品名称"
              >
              </el-table-column>
              <el-table-column label="操作" align="center">
                <template slot-scope="scope">
                  <el-button
                    type="danger"
                    style="padding: 2px 3px"
                    plain
                    @click="handleDelGoods(scope)"
                    >删除</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </el-scrollbar>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button
          type="primary"
          @click="handleAddGoods"
          v-if="buttonVisibility.addGoods"
        >添加商品</el-button>
        <el-button
          type="primary"
          @click="handleSubmitGoods"
        >提交</el-button>
      </div>
    </el-dialog>

    <!-- 商品表格 -->
    <el-dialog
      title="商品列表"
      :visible.sync="goodsDialog"
      :close-on-click-modal="$store.state.closeOnClickModal"
      :close-on-press-escape="$store.state.closeOnPresEscape"
      width="800px"
    >
      <search-bar>
        <template>
          <el-input
            style="width: 200px; margin-right: 5px"
            clearable
            placeholder="输入商品名称"
            v-model="goodsName"
            @keydown.native.enter="getGoodsList(1)"
          >
          </el-input>
          <el-button
            type="primary"
            icon="el-icon-search"
            @click="getGoodsList(1)"
            v-if="buttonVisibility.search"
            >搜索</el-button
          >
        </template>
      </search-bar>
      <el-table
        :data="goodsList"
        stripe
        border
        tooltip-effect="dark"
        height="300px"
      >
        <el-table-column label="序号" align="center" width="50">
          <template slot-scope="scope">
            <span>{{ (currPage - 1) * pageSize + scope.$index + 1 }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="code"
          align="center"
          width="160"
          show-overflow-tooltip
          label="商品编号"
        >
        </el-table-column>
        <el-table-column
          prop="name"
          align="center"
          width="160"
          show-overflow-tooltip
          label="商品名称"
        >
        </el-table-column>
        <el-table-column
          prop="entname"
          align="center"
          show-overflow-tooltip
          label="机构名称"
        >
        </el-table-column>
        <el-table-column
          prop="specification"
          label="商品规格"
          width="120"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="packingNnit"
          label="包装单位"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="producer"
          label="生产厂家"
          width="120"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column label="操作" align="center" width="100">
          <template slot-scope="scope">
            <el-button
              type="primary"
              style="padding: 2px 3px"
              plain
              @click="handleGoodsItem(scope)"
              v-if="buttonVisibility.add"
              >添加</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <pagination
        :allPage="allPage2"
        :pageSize="pageSize2"
        :currIndex="currPage2"
        @hanSiChange="hanSiChange2"
        @hanCurrChange="hanCurrChange2"
      ></pagination>
    </el-dialog>

    <el-dialog
      title="操作说明"
      :visible.sync="explain"
      :close-on-click-modal="$store.state.closeOnClickModal"
      :close-on-press-escape="$store.state.closeOnPresEscape"
      width="70%"
    >
      <div class="explain-text">
        <p>该界面可创建商品分类树形菜单</p>
        <p>
          使用说明：在列表中直接 “添加商品” 或在
          商品列表->商品详情->编辑中绑定商品分类
        </p>
        <p>
          使用范围：PC商城中分类筛选商品；App
          “分类”界面根据分类查看商品，“全部商品” 界面根据商品分类 “筛选” 商品
        </p>
        <p>
          备注：<span style="font-weight: bold">请尽量在二级分类绑定商品</span
          >，促销活动界面选择促销商品按照分类选择时只能选择二级
        </p>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import ImgUpload from "@/components/ImgUpload";
import { mapState } from 'vuex';

export default {
  name: "productClassify",
  data() {
    return {
      /**表格数据 */
      // {
      //   id: "分类ID",
      //   parentId:"编号",
      //   name:"类别名称",
      //   classifyId:"类别名称",
      //   grade:"级别",
      //   sort:"排序",
      //   imgUrl:"图片地址",
      //   childs:[]
      // }
      tableData: [],
      /**分页数据 */
      currPage: 1,
      pageSize: 20,
      allPage: 0,
      /**select选中项 */
      selectedList: [],
      /**新增drawer */
      addDrawer: false,
      /**新增分类表单 */
      //父类别 排序 类别名称 分类图片 调用别名 seo标题 seo描述
      addForm: {
        parent: "",
        sort: "",
        name: "",
        img: "",
        alias: "",
        seoTit: "",
        seoDes: "",
      },
      addFormRule: {
        parent: "",
        sort: "",
        name: "",
        img: "",
        alias: "",
        seoTit: "",
        seoDes: "",
      },

      /**批量添加商品 */
      addGoodsForm: {
        name: "", //分类名称
        id: "", //分类id
        list: [], //{id、name}
      },
      goodsName: "", //检索使用，商品名称
      addGoodsDialog: false, //dialog
      goodsDialog: false, //dialog
      goodsList: [], //查询到的商品列表
      /**分页数据 */
      currPage2: 1,
      pageSize2: 20,
      allPage2: 0,

      /**使用说明 */
      explain: false,
      id: "",
    };
  },
  computed: {
    ...mapState(['buttonPermissions']),
    // 按钮权限
    buttonVisibility() {
      const buttonsLimit = this.buttonPermissions?.['商品分类'] || [] ;
      // console.log('商品分类buttonsLimit', buttonsLimit);
      return {
        category: buttonsLimit.includes('新增分类'),
        delete: buttonsLimit.includes('删除'),
        addGoods: buttonsLimit.includes('添加商品'),
        add: buttonsLimit.includes('添加'),
        import: buttonsLimit.includes('导入'),
        search: buttonsLimit.includes('搜索'),
        sure: buttonsLimit.includes('确定'),
        cancel: buttonsLimit.includes('取消'),
        submit: buttonsLimit.includes('提交'),
        edit: buttonsLimit.includes('编辑'),
        details: buttonsLimit.includes('详情'),
      }
    }
  },
  components: {
    ImgUpload,
  },
  mounted() {
    this.getTableData();
  },
  methods: {
    dropdownCommand(row) {
      console.log(row);
      this.id = row.classifyId;
      this.$refs.upload.handleClick();
    },
    // 商品详情图片上传回调
    uploadGoods(file) {
      file = file.slice(0, 200); //最多可选择200张，多余的将会截断
      if (file.length) {
        let fileData = new FormData();
        for (let i = 0; i < file.length; i++) {
          fileData.append("file", file[i]);
          fileData.append("categoryId", this.id);
        }
        this.$uploadRequest({
          url: "/Management/GoodsAdmin/SaveGoodsCategoriesToExcel",
          method: "post",
          data: fileData,
        })
          .then((res) => {
            if (res.flag == 0) {
              this.$confirm(res.message + "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
              }).then(() => {});
            } else {
              this.$confirm(res.message + "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
              }).then(() => {});
            }
          })
          .catch((err) => {
            window.console.log(err);
          });
      }
    },
    updata() {
      this.getTableData();
    },
    /**获取表格 */
    getTableData() {
      let data = {
        type: "GetGoodsCategory",
        PageIndex: this.currPage,
        PageSize: this.pageSize,
      };
      let proc = "Proc_Admin_Category"; //存储过程名
      let type = "ReturnList";
      this.$requestSys({
        url:
          "goods/ashx/ReturnJson.ashx?type=" +
          type +
          "&json=" +
          encodeURIComponent(JSON.stringify(data)) +
          "&proc=" +
          proc,
        method: "post",
      })
        .then((res) => {
          this.tableData = [];
          if (res.flag == 0) {
            this.changeArr(res.data);
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },
    /**递归调用函数 */
    changeArr(list) {
      let obj = {};
      obj[0] = [];
      for (let i = 0; i < list.length; i++) {
        if (list[i].class_layer == 1) {
          obj[0].push({
            parentId: list[i].parent_id,
            name: list[i].title,
            classifyId: list[i].id,
            grade: list[i].class_layer,
            sort: list[i].sort_id,
            imgUrl: list[i].img_url || "",
            childs: [],
          });
        } else {
          if (!obj[list[i].parent_id]) {
            obj[list[i].parent_id] = [];
          }
          obj[list[i].parent_id].push({
            parentId: list[i].parent_id,
            name: list[i].title,
            classifyId: list[i].id,
            grade: list[i].class_layer,
            sort: list[i].sort_id,
            imgUrl: list[i].img_url || "",
            childs: [],
          });
        }
      }
      for (let i = 0; i < obj[0].length; i++) {
        obj[0][i].childs = obj[obj[0][i].classifyId];
      }
      this.allPage = obj[0].length;
      this.tableData = obj[0];
    },

    /**刷新表格数据 */
    handleRefresh() {
      this.getTableData();
    },
    /**分页size改变 */
    hanSiChange(val) {
      this.pageSize = val;
    },
    /**当前页改变 */
    hanCurrChange(val) {
      this.currPage = val;
    },

    /**客户 selection change触发事件 */
    selectionChange(section) {
      //存放选中的表格数据
      this.selectedList = section;
    },

    /**点击删除 */
    handleDel() {
      let row = {};
      if (this.selectedList.length == 1) {
        // this.$confirm("确定删除吗?", "提示", {
        //   confirmButtonText: "确定",
        //   cancelButtonText: "取消",
        //   type: "error",
        // })
        //   .then(() => {
        row = this.selectedList[0];
        // this.deteDel(row);
        //     })
        //     .catch(() => {});
        // } else {
        //   this.$message({
        //     message: "只能删除一条数据",
        //     type: "warning",
        //   });
      }
      this.$confirm("确定删除该条数据吗", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "error",
      })
        .then(() => {
          let data = {
            id: row.classifyId,
            type: "DltCategory",
          };
          let proc = "Proc_Admin_Category"; //存储过程名
          let type = "ReturnNumber";
          this.$requestSys({
            url:
              "goods/ashx/ReturnJson.ashx?type=" +
              type +
              "&json=" +
              encodeURIComponent(JSON.stringify(data)) +
              "&proc=" +
              proc,
            method: "post",
          }).then((res) => {
            if (res.flag == 0) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
              this.handleRefresh();
            } else {
              this.$message({
                message: res.message,
                type: "error",
              });
            }
          });
        })
        .catch(() => {});
    },

    /**新增/编辑分类 */
    handleAdd(row) {
      //将对象转为json再通过url传递
      let prams = null;
      if (row) {
        prams = encodeURIComponent(
          JSON.stringify({ id: row.classifyId, grade: row.grade })
        );
      } else {
        prams = row;
      }
      this.$router.push({
        path: "addProClassify",
        query: {
          prams: prams,
        },
      });
      prams = null;
    },

    /**关闭drawer 清空表单信息 */
    clearForm() {
      this.$refs["addForm"].resetFields();
      for (const key in this.addForm) {
        this.addForm[key] = null;
      }
      this.addDrawer = false;
    },
    /**提交新增分类 */
    submit() {
      this.$refs["addForm"].validate((valid) => {
        if (valid) {
          this.$message({
            message: "执行提交",
            type: "info",
          });
        }
      });
    },

    /**商品绑定 */
    /**查看分类商品，弹出一个dialog显示表单，将选择的商品存放在暂存区 */
    handleGoods({ row }) {
      // this.addGoodsDialog = true;
      // this.addGoodsForm.name = row.name;
      // this.addGoodsForm.id = row.classifyId;
      // this.getGoodsList();
      this.$router.push({
        path: "ClassifyGoods",
        query: {
          id: row.classifyId,
          title: row.name,
        },
      });
    },
    /**添加商品，打开商品列表 */
    handleAddGoods() {
      this.goodsDialog = true;
    },
    /**提交商品信息 */
    handleSubmitGoods() {
      if (this.addGoodsForm.list.length == 0) {
        this.$message({
          message: "暂未绑定商品",
          type: "error",
        });
        return;
      }
      this.$alert("确定提交吗？", "提示", {
        confirmButtonText: "确定",
        callback: () => {
          this.$request({
            method: "post",
            url: "/GoodsAdmin/SaveGoodsCategoryList",
            data: {
              entId: this.entId,
              categoryId: this.addGoodsForm.id,
              goodsStr: this.addGoodsForm.list.map((item) => item.id).join(),
            },
          })
            .then((res) => {
              let type = "success";
              if (res.success) {
                this.addGoodsDialog = false;
                this.addGoodsForm.list = [];
                this.addGoodsForm.id = "";
                this.addGoodsForm.name = "";
              } else {
                type = "error";
              }

              this.$message({
                message: res.message,
                type,
              });
            })
            .catch((err) => {
              window.console.log(err);
            });
        },
      });
    },
    /**分页size改变 */
    hanSiChange2(val) {
      this.pageSize2 = val;
      this.getGoodsList();
    },
    /**当前页改变 */
    hanCurrChange2(val) {
      this.currPage2 = val;
      this.getGoodsList();
    },
    /**选中某一个商品 */
    handleGoodsItem({ row }) {
      // 判断数组中是否存该条数据
      let repeat = this.addGoodsForm.list.some((item) => item.id == row.id);
      if (repeat) {
        this.$message({
          message: "该商品已存在",
          type: "warning",
        });
      } else {
        this.$message({
          message: "添加成功",
          type: "success",
          duration: 1000,
        });
        this.addGoodsForm.list.push(row);
      }
    },
    /**删除选中的某一个商品 */
    handleDelGoods({ $index }) {
      this.addGoodsForm.list.splice($index, 1);
    },
    /**获取表格 */
    getGoodsList(num) {
      this.currPage2 = num == 1 ? 1 : this.currPage2;
      let data = {
        type: "GoodsList",
        category: "0",
        attribute: "0",
        status: "9",
        strWhere: this.goodsName,
        PageIndex: this.currPage2,
        PageSize: this.pageSize2,
        promtype: "",
        promstatus: "99",
        goodsPic: "99",
        spStatus: "99",
      };
      let proc = "Proc_Admin_GoodsList"; // 存储过程名
      let type = "ReturnList";
      this.$requestSys({
        url:
          "goods/ashx/ReturnJson.ashx?type=" +
          type +
          "&json=" +
          encodeURIComponent(JSON.stringify(data)) +
          "&proc=" +
          proc,
        method: "post",
      })
        .then((res) => {
          this.allPage2 = res.recordCount;
          this.goodsList = [];
          if (res.flag == 0) {
            for (let i = 0; i < res.data.length; i++) {
              this.goodsList.push({
                id: res.data[i].article_id,
                code: res.data[i].goodscode,
                name: res.data[i].sub_title,
                entname: res.data[i].entname,
                entid: res.data[i].entId,
                specification: res.data[i].drug_spec,
                packingNnit: res.data[i].package_unit,
                producer: res.data[i].drug_factory,
                classify: res.data[i].category,
                repertory: res.data[i].stock_quantity,
                retailPrice: res.data[i].price,
                validTime: res.data[i].valdate,
                articleId: res.data[i].article_id,
                organId: res.data[i].adminentid,
                status: res.data[i].status,
                sort: res.data[i].sort_id,
              });
            }
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },
  },
};
</script>

<style scoped>
.productClassify {
  width: 100%;
  height: 100%;
}
</style>
